var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBulb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 53.936
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 56650"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Union 120",
    d: "M9.52 52.7l2.113-8.7H8a8 8 0 01-8-8V8a8 8 0 018-8h28a8 8 0 018 8v28a8 8 0 01-8 8H25.2l-14.276 9.834A1 1 0 019.52 52.7z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 56647"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 56646"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 75051",
    d: "M30.607 20.997a8.548 8.548 0 10-14.6 6.081 9.789 9.789 0 012.511 4.345l.689 2.569h5.6l.653-2.432a9.817 9.817 0 012.588-4.421 8.612 8.612 0 002.559-6.142z",
    fill: "#f4d242"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 75052",
    d: "M23.359 36.999h-2.732a1.453 1.453 0 01-1.48-1.307l-.231-2.821 6.187-.04-.264 2.861a1.454 1.454 0 01-1.48 1.307z",
    fill: "#59595b"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 75053",
    d: "M24.547 34.063c-1.728.074-3.463-.015-5.191.062a.12.12 0 00.009.238c1.729.058 3.464-.05 5.194.005.193.006.184-.314-.012-.305z",
    fill: "#808183"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 75054",
    d: "M24.547 34.819c-1.728.074-3.463-.015-5.191.062a.12.12 0 00.009.238c1.729.058 3.464-.05 5.194.005.193.006.184-.314-.012-.305z",
    fill: "#808183"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 56648",
    fill: "#f4d242"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 75055",
    d: "M22.762 8.005c0 .555-.293 2.55-.654 2.55s-.654-2-.654-2.55.293-1 .654-1 .654.445.654 1z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 75056",
    d: "M30.913 11.069c-.418.362-1.729 1.886-1.494 2.162s1.928-.8 2.346-1.162.565-.879.33-1.155-.764-.206-1.182.155z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 75057",
    d: "M34.09 19.973c-.546.07-2.548.029-2.593-.332s1.882-.905 2.428-.975 1.026.166 1.072.527-.363.71-.907.78z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 75058",
    d: "M14.05 10.407c.434.342 1.812 1.8 1.589 2.091s-1.962-.711-2.4-1.054-.6-.852-.382-1.139.76-.24 1.193.102z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 75059",
    d: "M9.91 18.547c.546.07 2.548.029 2.593-.333s-1.882-.905-2.428-.975-1.026.166-1.072.527.361.711.907.781z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 56649",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 75060",
    d: "M25.758 25.382a2.21 2.21 0 01-.644-.766 2.724 2.724 0 00.5-1.386 8.805 8.805 0 00.049-.887.765.765 0 00-.273-.706c-.214-.158-.5-.016-.664.138a1.6 1.6 0 00-.355.711 3.214 3.214 0 00-.052 1.512 3.019 3.019 0 00.143.51 1.3 1.3 0 01-.411.22.856.856 0 01-1.037-.522 2.862 2.862 0 01-.1-.208c.037-.1.072-.2.1-.3a6.223 6.223 0 00.286-1.476c.033-.415.044-.91-.352-1.156a.259.259 0 00-.35.093 3.093 3.093 0 00-.232 2.8 6.038 6.038 0 01-.352.709c-.145.252-.422.64-.758.591-.313-.046-.563-.442-.718-.686a2.786 2.786 0 01-.274-.57 5.75 5.75 0 00.111-.32 5.9 5.9 0 00.243-1.308c.029-.37.041-.888-.36-1.065a.259.259 0 00-.351.093 3.725 3.725 0 00-.2 2.492c.007.028.016.057.025.085a5.482 5.482 0 01-1.062 1.693c-.2.221.117.546.327.33a5.738 5.738 0 00.993-1.387 3.65 3.65 0 00.26.42 1.466 1.466 0 001.061.733 1.342 1.342 0 001.036-.673 3.512 3.512 0 00.3-.5 1.352 1.352 0 00.95.68 1.556 1.556 0 001.086-.282 3.261 3.261 0 00.711.847.293.293 0 10.364-.459zm-2.944-3.592a3.27 3.27 0 01-.041.586 4.953 4.953 0 01-.113.679 2.385 2.385 0 01.15-1.265zm2 1.3a2.464 2.464 0 01.143-.627 1.28 1.28 0 01.124-.259.557.557 0 01.04-.05.415.415 0 01.01.062 4.489 4.489 0 01-.177 1.585 1.512 1.512 0 01-.071.18 2.979 2.979 0 01-.076-.893z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 75061",
    d: "M26.24 24.115a204.25 204.25 0 01-2.893 8.329.271.271 0 00.5.2 143.417 143.417 0 002.829-8.355c.09-.288-.341-.466-.436-.174z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 75062",
    d: "M17.973 23.939c.725 2.849 1.4 5.712 2.005 8.59a.271.271 0 00.532-.1 143.88 143.88 0 00-2.074-8.577c-.075-.295-.539-.213-.463.087z"
  })))));
}
export default SvgBulb;